import React from 'react';

import { PrerenderContainer } from '../PrerenderContainer/PrerenderContainer';

export const PrerenderBasketContainer = () => {
  return ( <PrerenderContainer storeData cart />
  );
};

PrerenderBasketContainer.displayName = 'PrerenderBasketContainer';
